import { Component } from "@angular/core";
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
    selector: 'icon-action-renderer',
    templateUrl: './icon-action-renderer.component.html',
    standalone: false
})
export class IconActionRendererComponent implements AgRendererComponent {
    params: any;

    constructor() {
    }

    agInit(params): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        return false;
    }

    onClick(index): void {
        this.params.buttons[index].action(this.params.data);
    }

    isVisible(index): boolean {
        if (this.params.buttons[index].isVisible)
            return this.params.buttons[index].isVisible(this.params.data);
        else
            return true;
    }
}

export type CellAction = (params) => void;